// ----------------------------------------------------------------------

const account = {
  displayName: 'FDC Admin',
  email: 'admin@fdc-group.com',
  photoURL: '/assets/images/avatars/avatar_1.jpg'
}

export default account
